import PlatformService from '@/modules/platform/services/PlatformService';

const getPlatformLink = (listing: any) => {
  const { platformListingId } = listing;
  if (!platformListingId) {
    return null;
  }
  return `https://www.airbnb.com/rooms/${platformListingId}`;
};

const getImageUrl = (listing: any, platformType: string) => {
  if (platformType === 'airbnb') {
    if (!listing.thumbnailUrl) {
      return null;
    }
    return listing.thumbnailUrl.replace('?aki_policy=small', '?im_w=1200');
  }

  return null;
};

const FEATURES = {
  AVAILABILITY: 'AVAILABILITY',
  LONG_TERM_DISCOUNTS: 'LONG_TERM_DISCOUNTS',
};

const featureCheck = (platformType: string, feature: string) => {
  if (platformType === PlatformService.TYPES.TYPE_AIRBNB) {
    return true;
  }
  if (platformType === `${PlatformService.TYPES.TYPE_IGMS}_${PlatformService.TYPES.TYPE_IGMS}`) {
    if (feature === FEATURES.AVAILABILITY) {
      return true;
    }
    if (feature === FEATURES.LONG_TERM_DISCOUNTS) {
      return false;
    }
  }
  if (platformType === PlatformService.TYPES.TYPE_IGMS) {
    if (feature === FEATURES.AVAILABILITY) {
      return true;
    }
    if (feature === FEATURES.LONG_TERM_DISCOUNTS) {
      return false;
    }
  }
  if (platformType === PlatformService.TYPES.TYPE_HOSTFULLY) {
    if (feature === FEATURES.AVAILABILITY) {
      return false;
    }
    if (feature === FEATURES.LONG_TERM_DISCOUNTS) {
      return false;
    }
  }
  if (platformType === PlatformService.TYPES.TYPE_OWNERREZ) {
    if (feature === FEATURES.AVAILABILITY) {
      return false;
    }
    if (feature === FEATURES.LONG_TERM_DISCOUNTS) {
      return false;
    }
  }
  return true;
};

export default {
  getPlatformLink,
  getImageUrl,
  featureCheck,
  FEATURES,
};
